import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { FormatHelperService } from '@shared/services/format-helper.service';

@Component({
    selector: 'app-center-details-component',
    templateUrl: './center-details.component.html',
    styleUrls: ['./center-details.component.scss'],
})
export class CenterDetailsComponent {
    @Input() center;
    @Input() telephone;
    @Input() idDossierMedical;
    @Output() callBack: EventEmitter<any> = new EventEmitter<any>();
    @Output() appointmentClicked: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('callBackBtn') callBackBtn: ElementRef;
    @ViewChild('moreAvailibilityBtn') moreAvailibilityBtn: ElementRef;
    maxNumberOfDaysToShow = 3;
    maxNumberOfAppointmentsByDay = 2;

    constructor(private router: Router) {}

    selectCenterToCallBack() {
        this.callBack.emit(this.center);
    }

    selectAppointment(appointment: any) {
        this.appointmentClicked.emit({
            appointment,
            center: this.center,
        });
    }

    setCenterBtnFocus(): void {
        if (this.callBackBtn) {
            this.callBackBtn.nativeElement.focus();
        } else if (this.moreAvailibilityBtn) {
            this.moreAvailibilityBtn.nativeElement.focus();
        }
    }

    navigateToAppointmentDetails(): void {
        this.router.navigateByUrl(
            '/souscription/appointment/appointment-details/' + this.center.idApi
        );
    }

    getFormattedTime(time: string): string {
        return FormatHelperService.getDateFormatted(time, 'HH[h]mm');
    }
}
